import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ib-box-info',
    templateUrl: './ib-box-info.component.html',
    styleUrls: []
})
export class IbBoxInfoComponent implements OnInit {

    @Input() boxInfoModel: IbBoxInfoModel;

    constructor () { }

    ngOnInit (): void {
    }

}
